<template>
  <div class="organization-calendar">
    <div class="organization-calendar-main">
      <FullCalendar class="organization-calendar-calendar" :options="calendarOptions">
        <template v-slot:eventContent="arg">
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
    <policy-detail />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import localesTr from "@fullcalendar/core/locales/tr";
import localesFr from "@fullcalendar/core/locales/fr";
import localesDe from "@fullcalendar/core/locales/de";
import PolicyDetail from "../../policy/component/policy-detail";

const locales = {
  tr: localesTr,
  en: undefined,
  fr: localesFr,
  de: localesDe,
};

export default {
  props: ["events"],
  components: {
    FullCalendar,
    PolicyDetail,
  },

  computed: {
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "", // "dayGridMonth,timeGridWeek,timeGridDay",
        },
        initialView: "dayGridMonth",
        initialEvents: this.events,
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        locale: locales[this.currentLanguage],
      };
    },
  },

  methods: {
    handleEventClick(clickInfo) {
      const type = clickInfo.event.extendedProps.type;
      const id = clickInfo.event.id;

      if (type == "task") {
        this.$store.commit("task/showTaskDetailModal", true);
        this.$store.dispatch("task/fetchDetail", id);
      } else if (type == "policy") {
        this.$store.commit("organizationPolicy/policyId", id);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.organization-calendar {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

.organization-calendar-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}

.organization-calendar-sidebar-section {
  padding: 2em;
}

.organization-calendar-main {
  flex-grow: 1;
  padding: 0.5rem;
}

.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>
